/**
 * ClientInitializer Component
 * 
 * @deprecated This component is no longer needed as client initialization
 * is now handled directly by SelectionContext on app startup.
 * 
 * The SelectionContext automatically:
 * - Loads client options on mount
 * - Auto-selects client if there's only one available
 * - Provides clientOptions to all components via useSelection()
 * 
 * This prevents duplicate API calls across pages.
 */
const ClientInitializer = () => {
  // Component no longer needed - SelectionContext handles initialization
  return null;
};

export default ClientInitializer;